import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { url } from "@recoil/Store";
import { useRecoilValue } from "recoil";
import Banner from "@components/common/Banner";
import { useLocation } from "react-router-dom";
import SubMenus from "@components/common/SubMenu";
export default function Main() {
    const location = useLocation();
    const item = useRecoilValue(url);
    return (_jsxs(_Fragment, { children: [(item) &&
                _jsx(Banner, { item: item }), (item) &&
                _jsx(SubMenus, { item: item })] }));
}
